// SingleMultiChoiceQuestion.tsx
// import { useState } from 'react';
import { AnswerConfig, QuestionConfig, QuestionType } from "../../data/QuestionConfig";
import {Box, Grid} from "@mui/material";
import { SQToggleButton } from "../SQToggleButton";
import { useTranslation } from "react-i18next";
import { useStoreDispatch, useStoreSelector } from "../../store/hooks";
import {
    selectAllAnswers,
    selectCurrentChoiceQuestionAnswers,
    toggleQuestionAnswer,
    updateQuestionAnswer,
} from "../../store/questionnaireSlice";

export default function SingleMultiChoiceQuestion({ questionConfig }: { questionConfig: QuestionConfig }) {
    const { t } = useTranslation();
    const answer = useStoreSelector(selectCurrentChoiceQuestionAnswers);
    const allAnswers = useStoreSelector(selectAllAnswers);
    const dispatch = useStoreDispatch();

    const filteredAnswers =
        questionConfig.filterAnswer === undefined
            ? questionConfig.answers
            : questionConfig.answers.filter(questionConfig.filterAnswer(allAnswers));
    const answerCount = filteredAnswers.length;
    const evenNumberOfAnswers = answerCount % 2 === 0;



    function getColSpan(index: number) {
        if (index === answerCount - 1 && !evenNumberOfAnswers) {
            return 12;
        }
        return answerCount > 4 ? 6 : 12;
    }

    function handleClick(answerConfig: AnswerConfig) {
        const value = answerConfig.value ?? answerConfig.text;
        if (questionConfig.canSelectMultipleOptions) {
            dispatch(toggleQuestionAnswer(value));
        } else {
            dispatch(updateQuestionAnswer([value]));
        }
    }

    // Rendering logic for the privacy question with health data agreement
   if (
        questionConfig.questionType === QuestionType.singleChoice ||
        questionConfig.questionType === QuestionType.multiChoice
    ) {
        return (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-around",
                        // height: "500px",
                        height: "100%",
                        my: 1,
                    }}
                >
                    <Grid container spacing={0.2}>
                        {filteredAnswers.map((answerConfig, index) => (
                            <Grid item xs={getColSpan(index)} md={6} key={answerConfig.text}>
                                <SQToggleButton
                                    selected={answer.includes(answerConfig.value ?? answerConfig.text)}
                                    fullWidth
                                    onClick={() => handleClick(answerConfig)}
                                >
                                    {answerConfig.image && (
                                        <Box /*mr={3}*/>
                                            <img
                                                src={answerConfig.image}
                                                alt=""
                                                style={{ height: 20 / filteredAnswers.length + "vh" }}
                                            />
                                        </Box>
                                    )}
                                    {t(answerConfig.text)}
                                </SQToggleButton>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

        );
    }

    return null; // Falls der Typ nicht passt
}
